import React from 'react';
import { Navigate } from 'react-router-dom';
import { getLandingRouteForUser } from '../shared/_helpers/landingRoute';
import { readCurrentUser } from '../shared/_helpers/currentUser';

// Role gate for routes that must stay reachable without a web session:
// /package, /make-payment and /confirm-payment are visited by the mobile-login
// payment path and mid-signup users, so unlike ProtectedRoutes this never
// requires a token — it only redirects a logged-in user whose role doesn't own
// the route. Presentation-layer only; the server's checks are the real control.
const RoleGate = ({ children, allowedRoles }) => {
  const currentUser = readCurrentUser();
  const userType = currentUser?.user?.userType;
  if (currentUser?.token && userType && !allowedRoles.includes(userType)) {
    return <Navigate to={getLandingRouteForUser(currentUser?.user)} replace={true} />;
  }
  return children;
};
export default RoleGate;
